import ClickOutside from './clickOutside.js';
import CopyOnClick from './copyOnClick.js';
import escKeyup from './escKeyup.js';
import intersect from './intersect.js';

export default {
    'click-outside': ClickOutside,
    'copy-on-click': CopyOnClick,
    'esc-keyup': escKeyup,
    intersect,
};
